var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      fill: "#d9fff9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.78,
    style: {
      fill: "#56e2cf"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.41 11.03h3.84v.81h-3.84zm9.01.91a.51.51 0 0 0 .36-.15.5.5 0 0 0 .14-.35.5.5 0 0 0-.5-.51.51.51 0 0 0-.51.51.47.47 0 0 0 .15.35.48.48 0 0 0 .36.15zm-1.83 0a.48.48 0 0 0 .36-.15.47.47 0 0 0 .15-.35.51.51 0 0 0-.51-.51.5.5 0 0 0-.5.51.5.5 0 0 0 .14.35.51.51 0 0 0 .36.15zm-1.82 0a.51.51 0 0 0 .36-.15.5.5 0 0 0 .14-.35.5.5 0 0 0-.5-.51.48.48 0 0 0-.36.15.51.51 0 0 0-.15.36.51.51 0 0 0 .15.35.48.48 0 0 0 .36.15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.8 9.36v10.7h3.35v2.58L16 20.06h6.2V9.36zm13.38 1v2.14H8.82v-2.13zm-5.44 8.68L12.16 21v-1.95H8.82v-5.53h12.36v5.53z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.69 14.91h8.63v.81h-8.63zm0 1.79h8.63v.81h-8.63z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.b86b021c9e9fd571d7f2c7f54c83c705.svg";
export { ForwardRef as ReactComponent };